import { Outlet, createFileRoute } from '@tanstack/react-router';

import { SearchResultsPanel } from '../-components/thread-list/search-results-panel';
import { ThreadListPanel } from '../-components/thread-list/thread-list-panel';

export const Route = createFileRoute('/_dashboard/mail/$folder')({
  component: FolderRoute,
});

function FolderRoute() {
  const { folder } = Route.useParams();
  const { q } = Route.useSearch();
  const list =
    q.trim() === '' ? (
      <ThreadListPanel folder={folder} />
    ) : (
      <SearchResultsPanel q={q} />
    );

  return (
    <div className="flex h-full overflow-hidden">
      {list}
      <Outlet />
    </div>
  );
}
